"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import ConnectButton from "./ConnectButton";
import DubuLogo from "./DubuLogo";
import ThemeToggle from "./ThemeToggle";

// Shared shell header: logo, section nav, theme, wallet. Extracted so Trade and Bridge
// don't each carry their own copy. Page-specific extras (e.g. the live ticker on Trade)
// render via `children` beside the logo.
const NAV = [
  { href: "/trade", label: "Trade" },
  { href: "/bridge", label: "Bridge" },
];

const AppHeader = ({ children }: { children?: React.ReactNode }) => {
  const path = usePathname();

  return (
    <header className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-6">
        <Link href="/" aria-label="Dubu Swap home">
          <DubuLogo />
        </Link>

        <nav className="flex items-center gap-1" aria-label="Sections">
          {NAV.map((n) => (
            <Link
              key={n.href}
              href={n.href}
              aria-current={path === n.href ? "page" : undefined}
              className={`rounded-md px-2.5 py-1.5 text-sm transition-colors ${
                path === n.href
                  ? "bg-raised text-fg"
                  : "text-fg-muted hover:text-fg"
              }`}
            >
              {n.label}
            </Link>
          ))}
        </nav>

        {children && (
          <>
            <div className="hidden h-8 w-px bg-line sm:block" aria-hidden="true" />
            <div className="hidden sm:block">{children}</div>
          </>
        )}
      </div>
      <div className="flex items-center gap-2">
        <ThemeToggle />
        <ConnectButton />
      </div>
    </header>
  );
};

export default AppHeader;
